module.exports = __webpack_public_path__ + "p3_img3.jpg?518c838a75413fa1d3f98727a147ab6a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img3.jpg
// module id = 105
// module chunks = 0